<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Site Image"
                    class="img-raised rounded
                     img-fluid"
                  />
                </div>
                <div class="name">
                  <h3 class="title">Site</h3>
                  
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
            El Site del CCA 
            </p>
          </div>
          <div class="profile-tabs">
            <tabs
              :tab-name="['Sistema eléctrico', 'Sistema de enfriamiento', 'Sistema contra incendios','Redes']"
              :tab-icon="['electrical_services', 'ac_unit', 'fire_extinguisher','settings_ethernet']"
              plain
              nav-pills-icons
              color-button="warning"
            >
              <!-- here you can add your content for tab-content -->
             
              <template slot="tab-pane-1">
                <div class="md-layout">

                    <div class="md-layout-item md-size-100 ml-auto">

                        <p style="font-weight: bold;">El sistema eléctrico consiste a grades rasgos de una planta de energía y 2 UPS Mitsubishi
Diamond Plus 1100 utilizando una configuración redundante aislada.</p>
<br>
                        <img :src="tabPane1[0].image" class="rounded" />
                        
                    </div>
                </div>
              </template>
               <template slot="tab-pane-2">
                <div class="md-layout">

                  <div class="md-layout-item md-size-100 mr-auto">

                        <p style="font-weight: bold;">
Dos sistemas de enfriamiento de precisión Gforce ultra marca Dataaire que proporcionan
20 toneladas de aire frío.</p>
<br>                   </div>
                      <div class="md-layout-item md-size-30 mr-auto">
                   
                  </div>
                 <div class="md-layout-item md-size-40 mr-auto">
                                        <img :src="tabPane2[0].image" class="rounded" />
                  </div>

                        <div class="md-layout-item md-size-30 mr-auto">
                                      
                  </div>

                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 ml-auto">

                    <p style="font-weight: bold;"> Sistema contra incencios con multiples tipos de supresión.
<br>
                    <ul>
                    <li>Extinción por agente limpio CO2</li>
                    <li>Agua nebulizada</li>
                    <li>Pre-acción Aspersor / Diluvio</li>

                    </ul>
                        
<br></p>

<br>
                   
                  </div>
                      <div class="md-layout-item md-size-33 mr-auto">
                   
                  </div>
     
                  <div class="md-layout-item md-size-33 mr-auto">
                   <img :src="tabPane3[0].image" class="rounded" />
                  </div>
                                        <div class="md-layout-item md-size-33 mr-auto">
                   
                  </div>
     
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/Electrico.png") },

      ],
      tabPane2: [
        { image: require("@/assets/img/dataAire.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/fire.jpg") },
        { image: require("@/assets/img/mbp.jpg") }
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/vue-mk-header.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/Data0.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
